//  For each product on the page
(function () {
    // save the section id from the script tag and find the section
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`#${sectionID}`);

    // exit if section is not found
    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }


    const product = JSON.parse(section.querySelector(".productV12JSON").textContent);
    let activeVariant = JSON.parse(section.querySelector(".activeVariantJSON").textContent);
    let quantity = 1;

    const hasSticky = !!section.querySelector(".productV12Sticky");

    // during dev mode, set the active variant to the window so it can be accessed in the console
    if (Shopify.theme.role === "development") {
        window.product = product;
        window.activeVariant = activeVariant;
    }

    /************
     Product Swipers
     ************/
    section.querySelectorAll(".productV12VisualWrap")?.forEach(element => {

        let thumbsSwiper = new Swiper(element.querySelector(".productV12VisualThumbs"), {
            slidesPerView: 5,
            spaceBetween: 10,
            loop: true,
            breakpoints: {
                800: {
                    slidesPerView: 6,
                    spaceBetween: 23
                }
            }
        })


        let productSwiper = new Swiper(element.querySelector(".productV12VisualSwiper"), {
            slidesPerView: 1,
            spaceBetween: 6,
            loop: true,
            navigation: {
                nextEl: element.querySelector(".productV12VisualSwiperNext"),
                prevEl: element.querySelector(".productV12VisualSwiperPrev"),
            },
            breakpoints: {
                800: {
                    spaceBetween: 23
                }
            },
            thumbs: {
                swiper: thumbsSwiper
            },
            autoHeight: true,
        });

    });

    // change slide on thumbnail click
    section.querySelectorAll(".productV12VisualThumbsSlide").forEach(element => {
        element.addEventListener("click", function () {
            // change slide
            productSwiper.slideTo(this.dataset.index - 1);
        });
    });


    /**************
     Update Product
     ***************/

    async function updateProduct() {
        // Find the active variant

        activeVariant = product.variants[0];


        // check if variant wasn't found
        if (!activeVariant) {
            section.querySelector(".productV12ATC").disabled = true;
            section.querySelector(".productV12ATC").textContent = "Not Available";
            return;
        }


        /**************
         Price
         ***************/
        // update price
        section.querySelectorAll('.productV12PriceReal').forEach(el => {
            el.textContent = price(activeVariant.price * quantity, true);
        });
        section.querySelectorAll('.productV12PriceCompare').forEach(el => {
            el.textContent = "";
        });
        if (activeVariant.compare_at_price > activeVariant.price) {
            section.querySelectorAll('.productV12PriceCompare').forEach(el => {
                el.textContent = price(activeVariant.compare_at_price * quantity, true);
            });
        }

        /**************
         ATC Enable/Disable
         ***************/

        // check if the variant is in stock
        if (activeVariant.available) {
            section.querySelector(".productV12ATC").disabled = false;
            section.querySelector(".productV12ATC").textContent = "Add To Cart";
        } else {
            section.querySelector(".productV12ATC").disabled = true;
            section.querySelector(".productV12ATC").textContent = "Sold Out";
        }

        // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }


    /**************
     Product Quantity
     ***************/

    // minus
    section.querySelector(".productV12QtyControl.minus")?.addEventListener("click", function () {
        if (quantity === 1) {
            return;
        }
        quantity--;
        section.querySelector(".productV12QtyValue").textContent = quantity;
        updateProduct();
    });

    // plus
    section.querySelector(".productV12QtyControl.plus")?.addEventListener("click", function () {
        quantity++;
        section.querySelector(".productV12QtyValue").textContent = quantity;
        updateProduct();
    });


    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    updateProduct();

    /**************
     Delivery time
     ***************/
    let deliveryExists = section.querySelector(".productV12Shipping") || false;
    if (deliveryExists) {
        // get cutoff time (0-24 hour)
        let cutoff = parseInt(section.querySelector(".productV12Shipping").dataset.cutoff);
        // get current time
        let now = new Date();
        let hours = now.getHours();
        let minutes = now.getMinutes();
        let seconds = now.getSeconds();

        // get time until next cutoff
        let timeUntilCutoff = (cutoff - hours) * 60 * 60 - (minutes * 60 + seconds);
        if (timeUntilCutoff < 0) {
            timeUntilCutoff += 24 * 60 * 60;
        }
        // convert to hours, minutes, seconds
        let hoursUntilCutoff = Math.floor(timeUntilCutoff / 3600);
        let minutesUntilCutoff = Math.floor((timeUntilCutoff % 3600) / 60);

        // update text (x hrs x mins)
        section.querySelector('.productV12ShippingOrderCutoff').textContent = `${hoursUntilCutoff} hrs ${minutesUntilCutoff} mins`;

        // update text every second
        setInterval(() => {
            // get current time
            now = new Date();
            hours = now.getHours();
            minutes = now.getMinutes();
            seconds = now.getSeconds();

            // get time until next cutoff
            timeUntilCutoff = (cutoff - hours) * 60 * 60 - (minutes * 60 + seconds);
            if (timeUntilCutoff < 0) {
                timeUntilCutoff += 24 * 60 * 60;
            }
            // convert to hours, minutes, seconds
            hoursUntilCutoff = Math.floor(timeUntilCutoff / 3600);
            minutesUntilCutoff = Math.floor((timeUntilCutoff % 3600) / 60);

            // update text (x hrs x mins)
            section.querySelector('.productV12ShippingOrderCutoff').textContent = `${hoursUntilCutoff} hrs ${minutesUntilCutoff} mins`;

        }, 1000);
    }


    /**************
     Product ATC
     ***************/

    async function addToCart() {

        // add loading animation to both buttons
        section.querySelector(".productV12ATC").classList.add("loading");
        if (hasSticky) section.querySelector(".productV12StickyATC").classList.add("loading");


        // if hot cocoa and sweetener is selected, use the hot cocoa product (separate product)

        let formData = {
            items: [{
                quantity: quantity,
                id: activeVariant.id,
            }]
        };


        // add product
        await addProduct(formData);

        // remove loading animation
        section.querySelector(".productV12ATC").classList.remove("loading");
        if (hasSticky) section.querySelector(".productV12StickyATC").classList.remove("loading");
    }

    section.querySelector('.productV12ATC').addEventListener("click", addToCart);

    // LP pages scroll to product links
    document.querySelectorAll(`a[href="#product"]`)?.forEach(link => {
        link.addEventListener("click", (e) => {
            e.preventDefault();
            section.scrollIntoView({behavior: "smooth"});
        })
    })


    // scroll to reviews
    section.querySelectorAll(`.productV12Reviews`)?.forEach(button => {
        button.addEventListener("click", () => {
            const reviewSection = document.querySelector(`#reviews`) || false;
            if (!reviewSection) return;
            reviewSection.scrollIntoView({behavior: "smooth"});
        })
    })

})();
